module.exports = __webpack_public_path__ + "../resources/img/complate_head.76e06da4.png";